import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { GlobalStore, Site } from './types';

export const useGlobalStore = create<GlobalStore>()(
  persist(
    (set) => ({
      devMode: false,
      isInitialized: false,
      currentSite: null,
      isSwitchingSite: false,
      setDevMode: (devMode: boolean) => set(() => ({ devMode })),
      setIsInitialized: (isInitialized: boolean) =>
        set(() => ({ isInitialized })),
      setCurrentSite: (currentSite: Site) => set(() => ({ currentSite })),
      setIsSwitchingSite: (isSwitchingSite: boolean) =>
        set({ isSwitchingSite }),
    }),
    {
      name: 'global-store',
      partialize: (state) => ({
        currentSite: state.currentSite,
        isSwitchingSite: state.isSwitchingSite,
      }),
    }
  )
);
